import { ToastContainer, toast } from 'react-toastify';
const ErrorToast = ({ message }) => {
  return (
    <div className="error-toast">
      <div className="toast-message">{message}</div>
    </div>
  );
};



// Success Toast Component
const SuccessToast = ({ message }) => (
  <div className="success-toast">
    <div className="toast-message">{message}</div>
  </div>
);


// Toast Functions
export const showSuccessToast = (message) => {
  toast.success(<SuccessToast message={message} />, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: 'custom-success-toast'
  });
};

// Custom toast function
export const showErrorToast = (message) => {
  toast.error(<ErrorToast message={message} />, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'custom-error-toast'
  });
};

// Add this to your root component (App.js or similar)
export const ToastProvider = () => {
  return <ToastContainer />;
};